import React from 'react';

import { View, Text, StyleSheet } from '@react-pdf/renderer';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  torque: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '600',
    lineHeight: '1.5px',
    color: '#6921C4',
  },
  headerContainer: {
    marginBottom: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    left: 0,
    right: 0,
    paddingTop: 10,
    paddingBottom: 10,
  },
  flex__start: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexGrow: 5,
    width: 50 + '%',
  },
  flex__end: {
    width: 50 + '%',
    alignItems: 'flex-end',
    marginTop: 10,
  },
  leftColumn: {
    flexDirection: 'column',
    flexGrow: 9,
  },
  tableRow__heading: {
    margin: 'auto',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: 100 + '%',
  },
  estimated__total__heading: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '600',
    marginTop: 15,
    marginBottom: 5,
  },
  estimated__total__para: {
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
    paddingTop: 2,
    lineHeight: '1.6px',
  },
  estimated__total__sig: {
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 80,
    paddingRight: 80,
    borderRadius: 5,
    marginTop: 7,
    border: '1px solid #8A9EAF',
  },
  table: {
    display: 'table',
    width: 90 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderRadius: 0,
    borderBottomWidth: 0,
    overflow: 'hidden',
    marginTop: 10,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  tableCell: {
    margin: 5,
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  tableRow: {
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
  },
  table__total: {
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    backgroundColor: 'rgba(231, 236, 244, .8)',
  },
  details__header: {
    width: 100 + '%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  details__header__last: {
    width: 100 + '%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    border: '1px solid #8A9EAF',
    borderTopWidth: 1,
    borderBottomWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
  },
  notes__main: {
    paddingTop: 10,
  },
  note__heading: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '500',
    paddingBottom: 5,
  },
  note__text: {
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
    padding: 7,
    marginTop: 5,
    lineHeight: '1.6px',
    border: '1px solid #8A9EAF',
  },
});

export default function EstimatedTotal({ data, currencySymbol }) {
  const {
    totalItems,
    subTotal,
    totalTax,
    discount,
    totalCost,
    notes,
    laborTip = 0,
  } = data;

  return (
    <>
      {notes ? (
        <View style={styles.notes__main} wrap={false}>
          <Text style={styles.note__heading}>Notes:</Text>
          <Text style={styles.note__text}>{notes}</Text>
        </View>
      ) : (
        <View style={styles.empty}>{/* sin */}</View>
      )}
      <View style={styles.headerContainer} wrap={false}>
        <View style={styles.flex__start}>
          <View style={styles.tableRow__heading}>
            <Text style={styles.estimated__total__heading}>
              Terms & Conditions:
            </Text>
            <Text style={styles.estimated__total__para}>
              Invoices must accompany all returns. Warranty is non-transferable
              and only valid for the purchaser named on the invoice. Approval
              for repairs, disassembly, alterations or replacements must be
              approved by us. We reserve the right to inspect any product prior
              to replacement or repair. Labor is only included if expressly
              stated on the front of the invoice. Payment for labor requires our
              approval of the estimate, proof of scheduled maintenance, and
              proof of work done. Labor cap is $50 per hour or 100% of the price
              of the part on the invoice. Labor coverage is for defected
              material only. No warranty on labor for parts ordered or sold
              wrong. The installer is responsible for ensuring the part fits and
              interchanges with the application before installation. Invoice
              year and model may not be the exact model and year as the
              vehicle/part provided. Glass breakage and paint damage is not
              covered under warranty. The car’s owner&apos;s manual should be
              checked before each use. If payments are made after the agreed
              date, the APR will be 39.99%.
            </Text>
          </View>

          <View style={styles.tableRow__heading}>
            <Text style={styles.estimated__total__heading}>Signature:</Text>
            <View style={styles.estimated__total__sig}>{/* sin */}</View>
          </View>
        </View>
        <View style={styles.flex__end}>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.details__header}>
                <Text style={styles.tableCell}>Total Items</Text>
                <Text style={styles.tableCellHeader}>{totalItems}</Text>
              </View>

              <View style={styles.details__header}>
                <Text style={styles.tableCell}>Subtotal</Text>
                <Text style={styles.tableCellHeader}>
                  {currencySymbol}
                  {subTotal}
                </Text>
              </View>

              <View style={styles.details__header}>
                <Text style={styles.tableCell}>Total Discount</Text>
                <Text style={styles.tableCellHeader}>
                  {currencySymbol}
                  {discount}
                </Text>
              </View>

              <View style={styles.details__header}>
                <Text style={styles.tableCell}>Total Tax</Text>
                <Text style={styles.tableCellHeader}>
                  {currencySymbol}
                  {totalTax}
                </Text>
              </View>

              <View style={styles.details__header}>
                <Text style={styles.tableCell}>Labor Tip</Text>
                <Text style={styles.tableCellHeader}>
                  {currencySymbol}
                  {laborTip}
                </Text>
              </View>
            </View>

            <View style={styles.table__total}>
              <View style={styles.details__header}>
                <Text style={styles.tableCellHeader}>Grand Total:</Text>
                <Text style={styles.tableCellHeader}>
                  {currencySymbol}
                  {totalCost}
                </Text>
              </View>
              <View style={styles.details__header__last}>
                <Text style={styles.tableCellHeader}>Paid Amount:</Text>
                <Text style={styles.tableCellHeader}>
                  {currencySymbol}
                  {totalCost}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
}
